import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControlStatus, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProfileType } from '../../../../store/constants';
import { ButtonAction } from '../../../action-button/constants';
import { ValidationService } from '../../../../common/services/validation.service';
import { AutoUnsubscribe } from '../../../../common/decorators/auto-unsubscribe.decorator';
import { ProfileReport, ProfileReportNames } from '../../../../store/models';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'ui-monitoring-profile-create-dialog',
  templateUrl: './monitoring-profile-create-dialog.component.html',
  styleUrls: ['./monitoring-profile-create-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class MonitoringProfileCreateDialogComponent implements OnInit {
  @Input() detailsForm: UntypedFormGroup;
  @Input() title: string;
  @Input() dialogRef: MatDialogRef<unknown>;
  @Input() subscriptionForm?: UntypedFormGroup;
  @Input() reportForm?: UntypedFormGroup;
  @Input() report?: ProfileReport;
  @Input() reportItemNameList?: ProfileReportNames[];
  @Input() isDeviationVisible?: boolean;
  @Input() subscriptionTitleTranslationKey = 'monitoring.profile.item.subscription';
  @Input() maxFieldsCount: number;
  @Output() createProfile: EventEmitter<void> = new EventEmitter<void>();
  buttonAction = ButtonAction;
  monitoringProfileType = ProfileType;
  isSubscriptionEnabled: boolean;
  isInvalid$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private subscriptions: Subscription[] = [];

  constructor(public validationService: ValidationService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.detailsForm?.statusChanges?.subscribe((status: FormControlStatus) =>
        this.isInvalid$.next(status === 'INVALID'),
      ),
    );
  }
}
